module.exports = __webpack_public_path__ + "static/media/number-of-sports-video.93407b27.mp4";